import initPhoneMask from "./initPhoneMask";

const handleKeydown = ( evt ) => {
	if (
		/[^\d\s\(\)\-\+]/.test( evt.key )
		&&
		evt.key !== 'Backspace'
		&&
		evt.key !== 'Delete'
		&&
		evt.key !== 'ArrowLeft'
		&&
		evt.key !== 'ArrowRight'
	)
	{
		evt.preventDefault();
		return;
	}
};

export const initInputs = () => {
	const inputs = document.querySelectorAll( 'form[action="/ajax/"] input[type="tel"]' );
	
	if ( !inputs.length )
	{
		return;
	}

	inputs.forEach( input => {
		initPhoneMask( input );
	} );

	Array.from( inputs ).forEach( ( it ) => {
		it.removeEventListener( 'keydown', handleKeydown );
		it.addEventListener( 'keydown', handleKeydown );
	} );
};

